/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, identity, none, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { JobWarrantyFilterDto, JobWarrantyTaskDto } from './job-warranty.dto';
import { jobWarrantyTaskMapper } from './job-warranty.mapper';

@Injectable()
export class JobWarrantyRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  complete(task: JobWarrantyTaskDto): Observable<JobWarrantyTaskDto> {
    return this.httpPut(
      `${this.bp}/jobs/${task.jobId}/warranty-tasks/${task.id}/complete`,
      task,
      jobWarrantyTaskMapper,
    );
  }

  create(task: JobWarrantyTaskDto): Observable<JobWarrantyTaskDto> {
    return this.httpPost(
      `${this.bp}/jobs/${task.jobId}/warranty-tasks`,
      task,
      jobWarrantyTaskMapper,
    );
  }

  delete(task: JobWarrantyTaskDto): Observable<void> {
    return this.httpDelete(
      `${this.bp}/jobs/${task.jobId}/warranty-tasks/${task.id}`,
      task,
      jobWarrantyTaskMapper,
      none(),
    );
  }

  get(jobId: ID, taskId: ID): Observable<JobWarrantyTaskDto> {
    return this.httpGet(
      `${this.bp}/jobs/${jobId}/warranty-tasks/${taskId}`,
      jobWarrantyTaskMapper,
    );
  }

  getList(jobId: ID, filter: JobWarrantyFilterDto): Observable<JobWarrantyTaskDto[]> {
    return this.httpGet(
      `${this.bp}/jobs/${jobId}/warranty-tasks`,
      filter,
      identity(),
      arrayOf(jobWarrantyTaskMapper),
    );
  }

  update(task: JobWarrantyTaskDto): Observable<JobWarrantyTaskDto> {
    return this.httpPut(
      `${this.bp}/jobs/${task.jobId}/warranty-tasks/${task.id}`,
      task,
      jobWarrantyTaskMapper,
    );
  }
}
